import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-category-gallery',
  templateUrl: './category-gallery.component.html',
  styleUrls: ['./category-gallery.component.scss']
})
export class CategoryGalleryComponent implements OnInit {

  @Input() selectedCategory: any;
  @Input() categoriesToDisplay: [];

  constructor() { }

  ngOnInit(): void {
  }

}
